var site = site || {};
var generic = generic || {};
var $ = jQuery;
